import lFind from "lodash/find";
import { CONSTS } from "../config/objectConst";
import { buildCampaignsSteps, stepTypeToName } from "./mapping.typed";
import { transformLegacyInformation } from "features/campaigns/legacy";

export const mapping = {
  campaignTransform: (item) => ({
    id: item.id,
    name: item.name,
    count: item.target_audience_count,
    statistics: item.statistics,
    email: item?.owner?.email,
    avatar: item?.owner?.linkedin_profile?.picture_url,
    entityId: item?.owner?.linkedin_profile?.linkedin_entity_id,
    nickname: item?.owner?.nickname,
    personaId: item?.owner?.persona_id,
    publicIdentifier: item?.owner?.linkedin_profile?.linkedin_public_identifier,
    linkedin_profile: item?.owner?.linkedin_profile,
    created: item.created,
    target_audience_count: item.target_audience_count,
    in_queue_count: item.in_queue_count,
    archive: item.archived,
    allowEditSteps: !item.archived && item.state !== "Completed",
    allowAddSteps: !item.archived && item.state === "Compose",
    events: item.actions,
    complete_reason: item.complete_reason ? item.complete_reason : false,
    pause_reason: item.pause_reason || "",
    information: transformLegacyInformation(item),
    completed_date: item.completed ? new Date(item.completed) : false,
    actions: buildCampaignsSteps(item.steps),
  }),
  buildCampaignsArray: (array) => array.map(mapping.campaignTransform),

  activeName(type) {
    return stepTypeToName[type];
  },
  buildCampaignsSteps,

  campaignsForTable: (array) =>
    array.map((item) => ({
      id: item.id,
      name: item.name,
      status: lFind(item.information, ["id", 1]).value,
      steps: item.actions,
      qtyContacts: lFind(item.information, ["id", 2]).value,
      events: item.events,
      complete_reason: item.complete_reason,
      statistics: item.statistics,
      nickname: item.nickname || "",
      personaId: item.personaId || "",
      email: item.email || "",
      avatar: item.avatar || "",
      entityId: item.entityId || "",
      publicIdentifier: item.publicIdentifier || "",
      linkedin_profile: item.linkedin_profile || "",
      target_audience_count: item.target_audience_count,
      pause_reason: item.pause_reason || "",
      in_queue_count: item.in_queue_count,
      created: item.created,
      date: [
        lFind(item.information, ["id", 3]).value,
        item.completed_date || false,
      ],
    })),

  buildActivity: (array) => {
    const newArray = array.map((item, index) => {
      const { campaign, execution } = item;

      const indexAction = lFind(execution.step_executions, { type: "Delay" })
        ? item.step_number > 0
          ? item.step_number
          : 1
        : item.step_number + 1;
      const header =
        item.operation_type === CONSTS.AVAILABLE_ACTIONS.Connect.Type
          ? "Note message"
          : CONSTS.AVAILABLE_ACTIONS.Message.Title;
      return {
        id: index,
        contact_id: execution.linkedin_contact.id,
        fullName: execution.linkedin_contact.full_name
          ? execution.linkedin_contact.full_name
          : execution.linkedin_contact.linkedin_public_identifier,
        campaign_name: `${campaign.name}`,
        campaign_id: campaign.id,
        activity: mapping.activeName(item.operation_type),
        campaignExecutions: execution.step_executions,
        start_in: item.run_in_minutes,
        state: execution.state,
        human_state: execution.human_state,
        actions: item.actions,
        indexAction,
        campaignExecutionId: execution.id,
        stepNumber: item.step_number,
        message: item.message,
        header,
        conversation_url: execution.conversation_url,
        avatar: execution.linkedin_contact.picture_url,
        entityId: execution.linkedin_contact.linkedin_entity_id,
        publicIdentifier: execution.linkedin_contact.linkedin_public_identifier,
      };
    });
    return newArray;
  },
};
